export const NEW_CHAT_ID = 'new';

export const paths = {
  telegram: { path: '/telegram', getHref: () => '/telegram' },
  auth: {
    signIn: {
      path: '/signin',
      getHref: (returnTo?: string) =>
        returnTo ? `/signin?returnTo=${encodeURIComponent(returnTo)}` : '/signin',
    },
    loginAlias: { path: '/login' },
    signOut: { path: '/signout', getHref: () => '/signout' },
  },
  app: {
    root: { path: '/app', getHref: () => '/app' },
    projects: { path: '/app/projects', getHref: () => '/app/projects' },
    newProject: {
      path: '/app/projects/new',
      getHref: () => '/app/projects/new',
    },
    workspaceChat: { path: '/app/chat', getHref: () => '/app/chat' },
    project: {
      path: '/app/projects/:projectId',
      getHref: (projectId: string) => `/app/projects/${projectId}`,
    },
    newChat: {
      path: '/app/projects/:projectId/chat/new',
      getHref: (projectId: string) => `/app/projects/${projectId}/chat/${NEW_CHAT_ID}`,
    },
    chat: {
      path: '/app/projects/:projectId/chat/:chatId',
      getHref: (projectId: string, chatId: string) => `/app/projects/${projectId}/chat/${chatId}`,
    },
    materialPreview: {
      path: '/app/projects/:projectId/materials/previews/:previewId',
      getHref: (projectId: string, previewId: string) =>
        `/app/projects/${projectId}/materials/previews/${previewId}`,
    },
  },
} as const;

export const NEW_PROJECT_PATH = paths.app.newProject.path;

export function newChatPath(projectId: string): string {
  return paths.app.newChat.getHref(projectId);
}

export function chatPath(projectId: string, chatId: string): string {
  return paths.app.chat.getHref(projectId, chatId);
}

/** Integrations keep the project the marketer came from, so a new connection binds to it. */
export function integrationsPath(projectId?: string): string {
  return projectId
    ? `/app/integrations?projectId=${encodeURIComponent(projectId)}`
    : '/app/integrations';
}

export function isProjectChatPath(pathname: string): boolean {
  return /^\/app\/projects\/[^/]+\/chat(\/|$)/.test(pathname);
}
